import React, { useEffect } from "react";
import "./style.css";
import {
  Layout,
  Breadcrumb,
  Button,
  Space,
  Form,
  Input,
  Row,
  Col,
  Checkbox,
  Upload,
  Spin
} from "antd";
import {
  CameraOutlined,
  LoadingOutlined,
  UserOutlined,
  SyncOutlined
} from "@ant-design/icons";
import Container from "../Layout/Container";
import { Link, useHistory, useLocation } from "react-router-dom";
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { useSelector, useDispatch } from 'react-redux';
import MaskedInput from 'antd-mask-input';
import { fetchSubAdminUser, editSubAdminSelector, clearState, updateSubadminUser } from './editSubAdminSlice';
const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;
const CheckboxGroup = Checkbox.Group;

const dashBoardTabOptions = [
  {
    title: 'View Only',
    dataIndex: 'viewOnly',
  },
  {
    title: 'Add Distribution List',
    dataIndex: 'addDistributionList',
  },
  {
    title: 'View Distribution List',
    dataIndex: 'viewDistributionList',
  },
  {
    title: 'Edit Distribution List',
    dataIndex: 'editDistributionList',
  },
  {
    title: 'Delete Distribution List',
    dataIndex: 'deleteDistributionList',
  },
];

const allProcessTabOptions = [
  {
    title: 'View Ongoing Seen Stamp',
    dataIndex: 'viewOnGoingProcess',
  },
  {
    title: 'Create Seen Stamp',
    dataIndex: 'createTemplates',
  },
  {
    title: 'View Seen Stamp Details',
    dataIndex: 'viewTemplates',
  },
  {
    title: 'Manage/edit Seen Stamp',
    dataIndex: 'manage/editTemplates',
  },
];

const branchOptions = [
  {
    title: 'View Branch',
    dataIndex: 'view',
  },
  {
    title: 'Enable/Disable Branch',
    dataIndex: 'enable/disable',
  },
  {
    title: 'Add Branch',
    dataIndex: 'add',
  },

  {
    title: 'edit Branch',
    dataIndex: 'edit',
  },
];

const IndOfficeOptions = [
  {
    title: 'View IO',
    dataIndex: 'view',
  },
  {
    title: 'Enable/Disable IO',
    dataIndex: 'enable/disable',
  },
  {
    title: 'Add IO',
    dataIndex: 'add',
  },

  {
    title: 'edit IO',
    dataIndex: 'edit',
  },
];

const IndDirectorateOptions = [
  {
    title: 'View ID',
    dataIndex: 'view',
  },
  {
    title: 'Enable/Disable ID',
    dataIndex: 'enable/disable',
  },
  {
    title: 'Add ID',
    dataIndex: 'add',
  },

  {
    title: 'edit ID',
    dataIndex: 'edit',
  },
];

// const userRolesTabOptions = [
//   {
//     title: 'View Only',
//     dataIndex: 'viewOnlyRoles',
//   }, 
//   {
//     title: 'Enable/Disable Roles',
//     dataIndex: 'enable/disableRoles',
//   }, 
//   {
//     title: 'Create Roles',
//     dataIndex: 'createRoles',
//   }, 

//   {
//     title: 'edit Roles',
//     dataIndex: 'editRoles',
//   }, 
// ];

const userRolesTabOptions = [
  {
    title: 'View Only',
    dataIndex: 'viewOnlyRoles',
  },
  {
    title: 'Enable/Disable Appointments',
    dataIndex: 'enable/disableRoles',
  },
  {
    title: 'Create Appointments',
    dataIndex: 'createRoles',
  },

  {
    title: 'edit Appointments',
    dataIndex: 'editRoles',
  },
];

const manageUsersTabOptions = [
  {
    title: 'View Only',
    dataIndex: 'viewOnlyUsers',
  },
  {
    title: 'Enable/Disable Users',
    dataIndex: 'enable/disableUser',
  },
  {
    title: 'Create Users',
    dataIndex: 'createUser',
  },
  {
    title: 'edit Users',
    dataIndex: 'editUser',
  },
];




export default function EditSubAdmin() {

  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const [isLoading, setLoading] = React.useState(false);
  const [isToast, setToast] = React.useState(false);
  const [loading, setloading] = React.useState(false);//Image loading ..
  const [imageUrl, setimageUrl] = React.useState("");
  const [fileList, setfileList] = React.useState([]);

  const { isFetching, isSuccess, isError, errorMessage, response, isUpdated, subadmindata } = useSelector(
    editSubAdminSelector
  );

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  };

  const handleUploadChange = (info) => {
    // console.log(info.fileList)
    if (info.file.status === "uploading" || info.file.status === "done") {
      setloading(true);
      setfileList(info.fileList);
      getBase64(info.file.originFileObj, (imgUrl) => {
        setloading(false);
        setimageUrl(imgUrl);
      });
      return;
    }
  };

  const [dashboardTabList, setdashboardTabList] = React.useState([]);
  const dashboardTabChange = (list) => {
    setdashboardTabList(list);
    // console.log("dashboardTab=> "+list);
  };


  const [allProcessTabList, setallProcessTabList] = React.useState([]);
  const allProcessTabChange = (list) => {
    setallProcessTabList(list);
    // console.log("allProcessTab=> "+list);
  };


  const [branchList, setbranchList] = React.useState([]);
  const branchChange = (list) => {
    setbranchList(list);
    //  console.log("manageB=> "+list);
  };

  const [indOffice, setindOffice] = React.useState([]);
  const indOfficeChange = (list) => {
    setindOffice(list);
    //  console.log("manageIo=> "+list);
  };

  const [indDirectorate, setindDirectorate] = React.useState([]);
  const indDirectorateChange = (list) => {
    setindDirectorate(list);
    //  console.log("manageId=> "+list);
  };


  const [userRolesTabList, setuserRolesTabList] = React.useState([]);
  const userRolesTabChange = (list) => {
    setuserRolesTabList(list);
    // console.log("userRolesTab=> "+list);
  };


  const [manageUsersTabList, setmanageUsersTabList] = React.useState([]);
  const manageUsersTabChange = (list) => {
    setmanageUsersTabList(list);
    // console.log("manageUsersTab=> "+list);
  };



  const [form] = Form.useForm();

  useEffect(() => {

    setLoading(true);
    setToast(false);
    dispatch(clearState());
    dispatch(fetchSubAdminUser(location.state.subAdminName.toLowerCase()));


  }, []);

  useEffect(() => {

    if (isError) {
      dispatch(clearState());
      setLoading(false);
      setToast(true);
      toast.error(errorMessage);

    }

    if (isUpdated) {
      setLoading(false);
      toast.success('Sub-admin edited successfully');
      history.push('/sub-admin');
      dispatch(clearState());
    }

    if (isSuccess) {

      setTimeout(() => {
        if (subadmindata.profilePic.length !== 0) {
          setimageUrl(subadmindata.profilePic);
        }
        form.setFieldsValue({
          fullname: subadmindata.fullName,
          username: subadmindata.username,
          emailId: subadmindata.email,
          contactno: subadmindata.phone,
        });


        if (subadmindata.permission) {

          subadmindata.permission.forEach(val => {

            if (val.dashboardTab) {
              let dref = [];
              val.dashboardTab.forEach(deptval => {
                dref.push(deptval)
              });
              setdashboardTabList(dref);
            }

            if (val.manageB) {
              let dref = [];
              val.manageB.forEach(deptval => {
                dref.push(deptval)
              });
              setbranchList(dref);
            }


            if (val.manageIo) {
              let dref = [];
              val.manageIo.forEach(deptval => {
                dref.push(deptval)
              });
              setindOffice(dref);
            }


            if (val.manageId) {
              let dref = [];
              val.manageId.forEach(deptval => {
                dref.push(deptval)
              });
              setindDirectorate(dref);
            }


            if (val.userRolesTab) {
              let dref = [];
              val.userRolesTab.forEach(deptval => {
                dref.push(deptval)
              });
              setuserRolesTabList(dref);
            }

            if (val.manageUsersTab) {
              let dref = [];
              val.manageUsersTab.forEach(deptval => {
                dref.push(deptval)
              });
              setmanageUsersTabList(dref);
            }

            if (val.allProcessTab) {
              let dref = [];
              val.allProcessTab.forEach(deptval => {
                dref.push(deptval)
              });
              setallProcessTabList(dref);
            }

          });

        }


        setLoading(false);
      }, 1000);


    }
  }, [isError, isUpdated, isSuccess, setLoading, form, setToast]);




  const onFinish = (values) => {

    let formData = new FormData();
    if (values.profilePic) {
      formData.append("profilePic", values.profilePic.fileList[0].originFileObj);
    }

    formData.append("username", values.username);
    formData.append("fullName", values.fullname);
    formData.append("phone", values.contactno);

    if (dashboardTabList && dashboardTabList.length !== 0) {
      formData.append("dashboardTab", JSON.stringify({ dashboardTab: dashboardTabList }));
    }

    if (manageUsersTabList && manageUsersTabList.length !== 0) {
      formData.append("manageUsersTab", JSON.stringify({ manageUsersTab: manageUsersTabList }));
    }
    if (userRolesTabList && userRolesTabList.length !== 0) {
      formData.append("userRolesTab", JSON.stringify({ userRolesTab: userRolesTabList }));
    }

    if (branchList && branchList.length !== 0) {
      formData.append("manageBPermission", JSON.stringify({ manageB: branchList }));
    }

    if (indOffice && indOffice.length !== 0) {
      formData.append("manageIoPermission", JSON.stringify({ manageIo: indOffice }));
    }

    if (indDirectorate && indDirectorate.length !== 0) {
      formData.append("manageIdPermission", JSON.stringify({ manageId: indDirectorate }));
    }

    if (allProcessTabList && allProcessTabList.length !== 0) {
      formData.append("allProcessTab", JSON.stringify({ allProcessTab: allProcessTabList }));
    }

    // console.log("data==> "+ JSON.stringify(formData));
    setLoading(true);
    dispatch(updateSubadminUser(formData));


  };

  const onFinishFailed = (errorInfo) => {
    // console.log('Failed:', errorInfo);
  };


  return (
    <>
      <Container>
        <Breadcrumb
          style={{ margin: "16px 0", paddingLeft: 50, marginBottom: 0 }}
          separator=">"
        >
          <Breadcrumb.Item><Link to="/sub-admin">Sub Admin</Link></Breadcrumb.Item>
          <Breadcrumb.Item>Edit Sub Admin</Breadcrumb.Item>
        </Breadcrumb>

        <div
          className="site-layout-content"
          style={{ marginTop: 0, paddingTop: 0 }}
        >
          <div style={{ padding: 24, paddingTop: 16 }}>

            <Spin indicator={antIcon} style={{ textAlign: 'center', width: '100%' }} spinning={isLoading} />
            {isToast &&
              <Toaster
                toastOptions={{
                  className: '',
                  style: {
                    border: '1px solid #713200',
                    padding: '16px',
                    color: '#713200',
                    marginTop: 50
                  },
                }}
              >
                {(t) => (
                  <ToastBar toast={t}>
                    {({ icon, message }) => (
                      <>
                        {icon}
                        {message}
                        {t.type !== 'loading' && (
                          <button onClick={() => toast.dismiss(t.id)}>X</button>
                        )}
                      </>
                    )}
                  </ToastBar>
                )}
              </Toaster>
            }


            <div>
              <Form
                layout="vertical"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 22 }}
                name="nest-messages"
                form={form}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                style={{ backgroundColor: "#ffffff" }}
              >
                <Row
                  style={{
                    paddingTop: 35,
                    paddingBottom: 20,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderTop: "1px solid #dfe0eb",
                    borderBottom: "2px solid #e8e8e8",
                  }}
                >
                  <Col span="5"></Col>
                  <Col span="18">
                    <h1
                      style={{
                        fontWeight: "bold",
                        fontStyle: "normal",
                        fontSize: 24,
                      }}
                    >
                      Edit Sub Admin
                    </h1>
                  </Col>
                </Row>
                <Row
                  style={{
                    paddingTop: 24,
                    paddingBottom: 135,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderBottom: "1px solid #dfe0eb",

                  }}
                >
                  <Col span="5"></Col>
                  <Col span="18">

                    <Form.Item>
                      <h2
                        style={{
                          fontWeight: "bold",
                          fontStyle: "normal",
                          fontSize: 20,
                        }}
                      >
                        Sub Admin Details
                      </h2>
                    </Form.Item>
                    <Row>
                      <Col span="5"></Col>
                      <Col span="10">
                        <Form.Item
                          name="profilePic"
                        >
                          <Upload
                            // listType="picture"
                            //name="avatar"
                            listType="picture-card"
                            // className="avatar-uploader"
                            showUploadList={false}
                            onChange={handleUploadChange}
                          >
                            {imageUrl ? (
                              <>
                                <img
                                  src={imageUrl}
                                  alt="avatar"
                                  sty
                                  le={{ width: "100%" }}
                                />
                                <div style={{ marginTop: 8 }}>
                                  {<CameraOutlined />}
                                </div>
                              </>
                            ) : (
                              <>
                                {loading ? (
                                  <LoadingOutlined />
                                ) : (
                                  <UserOutlined />
                                )}
                                <div style={{ marginTop: 8 }}>
                                  {<CameraOutlined />}
                                </div>
                              </>
                            )}
                          </Upload>
                        </Form.Item>
                      </Col>
                      <Col span="5"></Col>
                    </Row>
                    <Row style={{ marginTop: 15 }}>
                      <Col span="10">
                        <Form.Item
                          name="fullname"
                          rules={[
                            {
                              required: true,
                              message: 'Please full name!',
                            },
                          ]}
                          requiredMark={'optional'}
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Full Name*
                            </p>
                          }
                        >
                          <Input
                            className="formInput"
                            placeholder=""

                          />
                        </Form.Item>
                        <Form.Item
                          name={['emailId']}
                          rules={[
                            {
                              type: 'email',
                              message: 'The input is not valid E-mail!',
                            },
                            {
                              required: true,
                              message: 'Please input your E-mail!',
                            },
                          ]}
                          requiredMark={'optional'}
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Email ID*
                            </p>
                          }
                        >
                          <Input className="formInput" placeholder="" disabled />
                        </Form.Item>
                      </Col>
                      <Col span="11">
                        <Form.Item
                          name="username"
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              User Name*
                            </p>
                          }
                        >
                          <Input
                            className="formInput"
                            placeholder=""
                            disabled
                          />
                        </Form.Item>
                        <Form.Item
                          name="contactno"
                          rules={[
                            {
                              required: true,
                              message: 'Please enter contact no!',
                            },
                            //  {
                            //      pattern: new RegExp('^[+][0-9]{3}-[0-9]{3}-[0-9]{3}-[0-9]{4}$'),
                            //      message: 'Contact number is invalid'
                            //  }
                          ]}
                          requiredMark={'optional'}
                          label={
                            <p
                              style={{
                                fontStyle: "normal",
                                fontWeight: "normal",
                                fontSize: 16,
                                color: "#6B778C",
                                marginBottom: 0,
                              }}
                            >
                              Contact No*
                            </p>
                          }
                        >
                          <Input
                            type={'text'}
                            className="formInput"
                            placeholder=""
                            maxLength={30}
                          // min={1}
                          //  max={15}
                          />
                          {/* <MaskedInput className="formInput" mask="+111-111-111-1111"  placeholder="+234-119-545-1457" /> */}
                        </Form.Item>
                      </Col>
                      <Col span="3"></Col>
                    </Row>

                    <Form.Item style={{ marginTop: 25 }}>
                      <h2
                        style={{
                          fontWeight: "bold",
                          fontStyle: "normal",
                          fontSize: 20,
                          marginTop: 15,
                        }}
                      >
                        Assign Permision
                      </h2>
                    </Form.Item>

                    <Form.Item
                      label={
                        <p
                          style={{
                            fontStyle: "normal",
                            fontWeight: "normal",
                            fontSize: "16px",
                            color: "#6b778c",
                            marginTop: "5px",
                            marginBottom: "0",
                          }}
                        >
                          Dashboard Tab
                        </p>
                      }
                    >
                      <CheckboxGroup
                        // options={plainOptions}
                        className="first-item-disable-mycheckbox"
                        options={dashBoardTabOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                        value={dashboardTabList}
                        onChange={dashboardTabChange}
                      />

                      {/* <CheckboxGroup>
                                <Checkbox value={1}>
                                  Option 1
                                </Checkbox>

                            </CheckboxGroup> */}

                      {/* <CheckboxGroup  >
                                    {plainOptions.map(option => {
                                        return (<>
                                          <Checkbox key={option.name} checked={option.is_enabled}>{option.name}</Checkbox>
                                          </>
                                        )
                                    })}
                                </CheckboxGroup> */}

                    </Form.Item>
                    <Form.Item
                      label={<p className="manage-checkbox">All Seen Stamp Tab</p>}
                    >
                      <CheckboxGroup
                        options={allProcessTabOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                        value={allProcessTabList}
                        onChange={allProcessTabChange}
                      />
                    </Form.Item>

                    <Form.Item
                      label={<p className="manage-checkbox">Department Tab</p>}
                    >

                      <Form.Item
                        style={{ paddingTop: "20px", paddingLeft: "30px", paddingRight: "20px", paddingBottom: "inherit" }}
                        label={
                          <p
                            style={{
                              fontStyle: "normal",
                              fontWeight: "normal",
                              fontSize: "16px",
                              color: "#6b778c",
                              marginTop: "5px",
                              marginBottom: "0",
                            }}
                          >
                            Branch
                          </p>
                        }
                      >

                        <CheckboxGroup
                          options={branchOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                          value={branchList}
                          onChange={branchChange}
                        />

                      </Form.Item>

                      <Form.Item
                        style={{ paddingTop: "20px", paddingLeft: "30px", paddingRight: "20px", paddingBottom: "inherit" }}
                        label={
                          <p
                            style={{
                              fontStyle: "normal",
                              fontWeight: "normal",
                              fontSize: "16px",
                              color: "#6b778c",
                              marginTop: "5px",
                              marginBottom: "0",
                            }}
                          >
                            Independent Office
                          </p>
                        }
                      >

                        <CheckboxGroup
                          options={IndOfficeOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                          value={indOffice}
                          onChange={indOfficeChange}
                        />

                      </Form.Item>


                      <Form.Item
                        style={{ paddingTop: "20px", paddingLeft: "30px", paddingRight: "20px", paddingBottom: "inherit" }}
                        label={
                          <p
                            style={{
                              fontStyle: "normal",
                              fontWeight: "normal",
                              fontSize: "16px",
                              color: "#6b778c",
                              marginTop: "5px",
                              marginBottom: "0",
                            }}
                          >
                            Independent Directorates
                          </p>
                        }
                      >

                        <CheckboxGroup
                          options={IndDirectorateOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                          value={indDirectorate}
                          onChange={indDirectorateChange}
                        />

                      </Form.Item>

                    </Form.Item>

                    <Form.Item
                      label={<p className="manage-checkbox">Appointments Tab</p>}
                    >
                      <CheckboxGroup
                        options={userRolesTabOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                        value={userRolesTabList}
                        onChange={userRolesTabChange}
                      />
                    </Form.Item>
                    <Form.Item
                      label={<p className="manage-checkbox">Manage User Tab</p>}
                    >
                      <CheckboxGroup
                        options={manageUsersTabOptions.map(column => ({ label: column.title, value: column.dataIndex }))}
                        value={manageUsersTabList}
                        onChange={manageUsersTabChange}
                      />
                    </Form.Item>

                  </Col>
                </Row>

                <Row
                  style={{
                    paddingTop: 24,
                    paddingBottom: 24,
                    borderLeft: "1px solid #dfe0eb",
                    borderRight: "1px solid #dfe0eb",
                    borderBottom: "1px solid #dfe0eb",
                    marginBottom: 10,
                  }}
                >
                  <Col span="6"></Col>
                  <Col span="13" style={{ textAlign: "right", paddingRight: 12 }}>
                    <Space>
                      <Link to="/sub-admin">
                        <Button type="primary" size="large" ghost>
                          Cancel
                        </Button>
                      </Link>
                      <Button htmlType="submit" type="primary" size="large">
                        Submit
                      </Button>
                    </Space>
                  </Col>
                  <Col span="5"></Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}
